import { useRef, useState, useEffect, useLayoutEffect } from "react";

const images = [
    { src: "/Logos/Krepol.png", width: 130, height: 120, alt: "Krepol" },
    { src: "/Logos/AGFOODS_logo_color_CMYK-_1_.png", width: 120, height: 120, alt: "AGFOODS" },
    { src: "/Logos/Logo_current.png", width: 170, height: 100, alt: "Logo" },
    { src: "/Logos/logotyp_cover.png", width: 240, height: 100, alt: "Cover" },
    { src: "/Logos/msul_logo.jpg", width: 200, height: 100, alt: "MSUL" },
    { src: "/Logos/FALA.png", width: 220, height: 100, alt: "Fala" },
    { src: "/Logos/Faristo.jpg", width: 120, height: 120, alt: "Faristo" },
    { src: "/Logos/GGI_logo_without_tagline.svg.png", width: 350, height: 90, alt: "GreenGas" },
    { src: "/Logos/gibiec.png", width: 130, height: 90, alt: "TomaszGibiec" },
    { src: "/Logos/heliotronic.png", width: 130, height: 120, alt: "Heliotronic" },
    { src: "/Logos/kisbud.jpg", width: 200, height: 100, alt: "Kisbud" },
    { src: "/Logos/LAWENDOWE-SPA8-.png", width: 150, height: 100, alt: "LawendoweSpa" },
    { src: "/Logos/z+m.png", width: 140, height: 100, alt: "z+m" },
    { src: "/Logos/tk_max.png", width: 170, height: 100, alt: "tkmax" },
    { src: "/Logos/logo-ginzel-1.jpg", width: 200, height: 100, alt: "ginzel" },
    { src: "/Logos/Logo-ITN-gotowiec-100-x-75.jpg", width: 150, height: 100, alt: "ITN" },
    { src: "/Logos/Logo-s-R-silva.bmp", width: 280, height: 100, alt: "Mrózek" },
    { src: "/Logos/logo_1_big.png", width: 280, height: 100, alt: "CzasNaButy" },
    { src: "/Logos/logo_koga.jpg", width: 150, height: 120, alt: "Koga" },
    { src: "/Logos/Logo_pragmatyk_RGB-i.png", width: 300, height: 100, alt: "Pragmatyk" },
    { src: "/Logos/lokword-2.jpg", width: 230, height: 110, alt: "LokWorld" },
    { src: "/Logos/mb.png", width: 190, height: 100, alt: "MB", className: "bg-gray" },
    { src: "/Logos/MK-music-logo-01.png", width: 150, height: 120, alt: "MK-Music" },
    { src: "/Logos/nieboras.jpg", width: 150, height: 120, alt: "Nieboras" },
    { src: "/Logos/SKmeble.jpg", width: 270, height: 120, alt: "SKMeble" },
    { src: "/Logos/techne.png", width: 270, height: 120, alt: "Techne" },
    { src: "/Logos/Zenerta_logo.jpg", width: 270, height: 120, alt: "Techne" },
    { src: "/Logos/progres_logo.png", width: 290, height: 100, alt: "Techne" },
];

const SCROLL_SPEED = 1.5; // px na klatkę

const AutoScrollingGallery = () => {
    const wrapperRef = useRef<HTMLDivElement>(null);
    const innerRef = useRef<HTMLDivElement>(null);
    const breakRef = useRef<HTMLDivElement>(null);
    const [isPaused, setIsPaused] = useState(false);

    // Duplikujemy obrazy dla efektu zapętlenia i dodajemy break na końcu
    const allImages = [
        ...images,
        ...images,
        { type: "break" }
    ];

    // Ustaw scrollLeft na 0 po zamontowaniu i przy zmianie rozmiaru
    useLayoutEffect(() => {
        const wrapper = wrapperRef.current;
        if (wrapper) {
            wrapper.scrollLeft = 0;
        }
        const handleResize = () => {
            if (wrapper) {
                wrapper.scrollLeft = 0;
            }
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Automatyczne przewijanie - zawsze scrolluj, nie zatrzymuj na końcu
    useEffect(() => {
        const wrapper = wrapperRef.current;
        if (!wrapper) return;

        let animationFrame: number;

        const scroll = () => {
            if (!isPaused) {
                wrapper.scrollLeft += SCROLL_SPEED;
            }
            animationFrame = requestAnimationFrame(scroll);
        };

        animationFrame = requestAnimationFrame(scroll);
        return () => cancelAnimationFrame(animationFrame);
    }, [isPaused]);

    // IntersectionObserver do breaka
    useEffect(() => {
        const wrapper = wrapperRef.current;
        const breakDiv = breakRef.current;
        if (!wrapper || !breakDiv) return;

        let ticking = false;
        const observer = new window.IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting && !ticking) {
                        ticking = true;
                        // Reset scrolla i natychmiast odczekaj jedną klatkę, by nie zapętlić observera
                        // Ustaw na 1 zamiast 0, by uniknąć natychmiastowego ponownego wejścia breaka w viewport
                        wrapper.scrollLeft = 1;
                        setTimeout(() => { ticking = false; }, 100);
                    }
                });
            },
            {
                root: wrapper,
                threshold: 0.1 // mniejszy threshold, by szybciej łapało
            }
        );
        observer.observe(breakDiv);

        return () => observer.disconnect();
    }, []);

    return (
        <div style={{ position: "relative", width: "100vw", display: "flex", justifyContent: "center" }}>
            <div
                style={{
                    position: "relative",
                    width: "100%",
                    overflow: "hidden",
                }}
                onMouseEnter={() => setIsPaused(true)}
                onMouseLeave={() => setIsPaused(false)}
            >
                <div
                    ref={wrapperRef}
                    style={{
                        overflowX: "scroll",
                        overflowY: "hidden",
                        width: "100%",
                        height: "200px",
                        scrollbarColor: "#e0e0e0 #ffffff",
                        scrollbarWidth: 'none', // Firefox
                        msOverflowStyle: 'none', // IE
                        WebkitOverflowScrolling: 'unset',// Chrome, Safari
                        position: "relative",
                    }}
                    className="gallery-scrollbar"
                >
                    <div
                        ref={innerRef}
                        style={{
                            display: "flex",
                            whiteSpace: "nowrap",
                            gap: "10px",
                            padding: "10px",
                            minWidth: "200%",
                        }}
                    >
                        {allImages.map((img, idx) => {
                            if ((img as any).type === "break") {
                                return (
                                    <div
                                        key="break"
                                        ref={breakRef}
                                        style={{
                                            width: 60,
                                            height: 80,
                                            display: "inline-flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            background: "#eee",
                                            color: "#bbb",
                                            fontWeight: "bold",
                                            fontSize: 18,
                                            borderRadius: 8,
                                            marginRight: 10,
                                        }}
                                    >
                                        FAKE
                                    </div>
                                );
                            }
                            const image = img as typeof images[number];
                            return (
                                <div className="recomendations-grid-item" key={idx} style={{ flexShrink: 0 }}>
                                    <img
                                        src={image.src}
                                        width={image.width}
                                        height={image.height}
                                        alt={image.alt}
                                        className={image.className || ""}
                                        style={{ objectFit: "contain", display: "block" }}
                                    />
                                </div>
                            );
                        })}
                    </div>
                </div>
                {/* Custom scrollbar CSS */}
                <style>
                    {`
                    .gallery-scrollbar::-webkit-scrollbar {
                        height: 6px;
                    }
                    .gallery-scrollbar::-webkit-scrollbar-thumb {
                        background: #e0e0e0;
                        border-radius: 3px;
                    }
                    .gallery-scrollbar::-webkit-scrollbar-track {
                        background: transparent;
                    }
                    `}
                </style>
            </div>
        </div>
    );
};

export default AutoScrollingGallery;
